export const consult = [
  '英语咨询',
  '新概念咨询',
  '数学咨询',
  '语文咨询'
]



// WEBPACK FOOTER //
// ./src/api/js/primary/consult.js